import React, { useState, useEffect } from "react";
import styles from "./SettingModal.module.scss";
import ChangePlan from "../../templates/payment/ChangePlan";
import ChangePlanForOverseas from "../../templates/payment/ChangePlanForOverseas";

import type { NoticeType } from "../../../types/settingsTypes";

type Props = {
  client: {
    code: string;
    id: number;
    country_code: string;
    plan_code: string;
  };
  past_trial_plans: [];
  current_trial_plan: string;
  plans: object;
  plan_prices: object;
  member_count: number;
  available_trial_plans: [];
  changeModalCss: (width: string, height: string) => void;
  setHeaderShow: (show: boolean) => void;
  is_internal: boolean;
  locale: string;
  cardStatus: string;
};

const SettingFullContent = ({
  client,
  past_trial_plans,
  current_trial_plan,
  plans,
  plan_prices,
  member_count,
  available_trial_plans,
  changeModalCss,
  setHeaderShow,
  is_internal,
  locale,
  cardStatus,
}: Props) => {
  const [notice, setNotice] = useState<NoticeType>(null);
  const [settingFullContentHeight, setSettingFullContentHeight] = useState("670px");

  useEffect(() => {
    if (notice) {
      setTimeout(() => {
        setNotice(null);
      }, 7000);
    }
  }, [notice]);

  const handleModalShow = (setShow: (show: boolean) => void, width: string, height: string) => {
    changeModalCss(width, height);
    setSettingFullContentHeight("auto");
    setShow(true);
    setHeaderShow(false);
  };

  const handleModalClose = (setShow: (show: boolean) => void) => {
    changeModalCss("100%", "auto");
    setSettingFullContentHeight("670px");
    setShow(false);
    setHeaderShow(true);
  };

  return (
    <>
      {notice && (
        <div className="flash_message notice" style={{ zIndex: 9999 }}>
          {notice.message.split("/n").map((message) => (
            <>
              {message}
              <br />
            </>
          ))}
        </div>
      )}
      <div className={styles.settingFullContent} style={{ height: settingFullContentHeight }}>
        {is_internal ? (
          <ChangePlan
            client={client.code}
            client_id={client.id}
            past_trial_plans={past_trial_plans}
            current_trial_plan={current_trial_plan}
            plans={plans}
            plan_prices={plan_prices}
            members_count={member_count}
            available_trial_plans={available_trial_plans}
            setNotice={setNotice}
            handleModalShow={handleModalShow}
            handleModalClose={handleModalClose}
            changeModalCss={changeModalCss}
            cardStatus={cardStatus}
          />
        ) : (
          <ChangePlanForOverseas
            client={client.code}
            client_id={client.id}
            past_trial_plans={past_trial_plans}
            current_trial_plan={current_trial_plan}
            plans={plans}
            plan_prices={plan_prices}
            members_count={member_count}
            available_trial_plans={available_trial_plans}
            setNotice={setNotice}
            handleModalShow={handleModalShow}
            handleModalClose={handleModalClose}
            changeModalCss={changeModalCss}
            is_internal={is_internal}
            countryCode={client.country_code}
            locale={locale}
            plan_code={client.plan_code}
          />
        )}
      </div>
    </>
  );
};

export default SettingFullContent;
